<template>
  <Content>
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import { getChannels as fetchData } from "@/api/channels";

const columnsOptions = {
  sortable: "custom",
  controls: true,
  id: "type",
  edit: true,
};

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 50,
  },
  {
    prop: "title",
    label: "Название",
  },
  {
    prop: "type",
    label: "Тип",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData,
      },
    };
  },
};
</script>
